/* jshint ignore:start */
if (typeof define !== 'function') {
    var define = require('amdefine')(module)
}
/* jshint ignore:end */

define('pdfGear/generator/chart',[], function() {
    'use strict';

    var chartTitleStyle = {
            margin: [0, 15, 0, 10],
            fontSize: 14
        },
        chartTextStyle = {
            fontSize: 10,
            margin: [0, 125, 0, 125],
            alignment: 'center'
        };

    return {
        chartTitleStyle: chartTitleStyle,
        chartTextStyle: chartTextStyle,
        constructChart: constructChart
    };

    /**
     * Function to construct analytics chart for the given data. All charts have same format.
     * @param  {[type]} widget contains the object raw data to be represented as chart
     * @return  array of json objects
     */
    function constructChart(widget) {

        var chartTitleAndFiltersColumns = 1,
            chartTitleAndFiltersColumnWidths,
            filterCount = filterToShowCount(widget.filters);


        if (filterCount > 0) {
            chartTitleAndFiltersColumns += 1;
        }
        if (widget.dateGeneratedOn) {
            chartTitleAndFiltersColumns += 1;
        }

        if (chartTitleAndFiltersColumns === 3) {
            if(filterCount === 1){
                chartTitleAndFiltersColumnWidths = [200, 100, 160];
            } 
            if(filterCount === 2){
                chartTitleAndFiltersColumnWidths = [180, 120, 160];                
            }
        } else if (chartTitleAndFiltersColumns === 2) {
            chartTitleAndFiltersColumnWidths = [330, 140];
        } else {
            chartTitleAndFiltersColumnWidths = [470];
        }


        return [{
            table: {
                headerRows: 0,
                widths: chartTitleAndFiltersColumnWidths,
                body: [
                    createChartTitleAndFilterLayout(widget, chartTitleAndFiltersColumns),
                    addImage(widget, chartTitleAndFiltersColumns)
                ]
            },
            layout: {
                hLineWidth: function(i, node) {
                    return (i === 0 || i === node.table.body.length) ? 1 : 0;
                },
                vLineWidth: function(i, node) {
                    return (i === 0 || i === node.table.widths.length) ? 1 : 0;
                },
                hLineColor: function() {
                    return '#e5e5e5';
                },
                vLineColor: function() {
                    return '#e5e5e5';
                }
            },
            //margin between this and next widget
            margin: [0, 0, 0, 30]
        }];
    }

    function filterToShowCount(filters) {
        var filterCount = 0;

        if (filters.length) {
            filters.forEach(function(filter) {
                if (filter.filterListLength > 1) {
                    filterCount += 1;
                }
            });
        }

        return filterCount;
    }


    function createChartTitleAndFilterLayout(widget, chartTitleAndFiltersColumns) {
        var titleFilterLayoutArray = [],
            bodyContent;

        titleFilterLayoutArray.push({
            text: widget.subTitle,
            style: 'chartHeaderStyle'
        });

        if (chartTitleAndFiltersColumns === 3) {
            titleFilterLayoutArray.push({
                text: widget.dateGeneratedOn ? widget.dateGeneratedOn : '',
                style: 'chartHeaderStyle'
            });

            titleFilterLayoutArray.push({
                table: {
                    widths: (widget.filters.length && filterToShowCount(widget.filters) === 1) ? [110, 50] : [70,15,70,15],
                    body: [
                        formatChartFilters(widget.filters),
                    ]
                },
                layout: 'noBorders',
                //alignment: 'center',
                style: 'chartHeaderStyle',
                margin: [15, 3, 5, 0]
            });
        }

        if (chartTitleAndFiltersColumns === 2) {
            if (widget.filters.length && filterToShowCount(widget.filters)>0) {
                bodyContent = formatChartFilters(widget.filters);
            } else if (widget.dateGeneratedOn) {
                bodyContent = formatDataGenerationDate(widget.dateGeneratedOn);
            }

            titleFilterLayoutArray.push({
                table: {
                    widths: [100],
                    body: [
                        bodyContent,
                    ]
                },
                layout: 'noBorders',
                //alignment: 'center',
                style: 'chartHeaderStyle',
                margin: [20, 5, 20, 5]
            });
        }

        return titleFilterLayoutArray;

    }

    /**
     * function to insert image or text (if image is not available) in chart
     * @param widget raw data
     * @return javascript object
     */
    function addImage(widget, chartTitleAndFiltersColumns) {
        var returnImageArray = [];
        var imageElement = {};
        if (widget.image) {
            imageElement.image = widget.image.image;
            imageElement.alignment = 'center';
            imageElement.margin = [10, 15, 10, 5];
            imageElement.width = 400;
            imageElement.height = 250;

        } else {
            imageElement.text = widget.text;
            imageElement.style = 'chartTextStyle';
        }
        imageElement.colSpan = chartTitleAndFiltersColumns;
        imageElement.paddingTop = function() {
            return 0;
        };
        imageElement.paddingLeft = function() {
            return 20;
        };
        returnImageArray.push(imageElement);
        return returnImageArray;
    }

    /**
     * Fucntion to format filters for analytics charts. Filters are displayed on the title strip bar.
     * @param  array of javascript objects
     * @return array of javascript objects formatted according to pdfmake format.
     */
    function formatChartFilters(filters) {
        var bodyRow = [];
        var temp = {};
        //create column inside column 
        temp.columns = [];
        filters.forEach(function(filter) {

            temp.columns.push({
                text: filter.value ? filter.key : ''
            });

            if (filter.value) {
                temp.columns.push({
                    text: filter.value
                });

            } else if(filter.image){
			
                temp.columns.push({
                    image: filter.image.image,
                    height: 10,
                    width: filter.image.width,
                    alignment: 'center',
                    margin: [4, 0, 0, 0],

                });
            }
        });
        bodyRow.push(temp);
        return bodyRow;
    }

    function formatDataGenerationDate(dataGenerationDate) {
        var bodyRow = [];
        bodyRow.push({
            columns: [{
                text: dataGenerationDate,
                alignment: 'center',
                width: 'auto'
            }]
        });
        return bodyRow;
    }

});

